export const SET_RESUME_QUESTION_OBJECT = "SET_RESUME_QUESTION_OBJECT";

export const setResumeQuestionJson = (response) => {
  return {
    type: SET_RESUME_QUESTION_OBJECT,
    payload: response,
  };
};